import AddEditAgreementForm from "./forms/add-edit-agreement-form";
import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useStore } from "../../../contexts/store-provider";
import { observer } from "mobx-react";
import { initialAgreementValues } from "../../../core/initialState/add-edit-agreement-state";
import { IAddAgreement } from "../../../models/forms/IAgreement";
import { useHistory, useLocation } from "react-router-dom";
import LanguageSlider from "../../../shared-components/language-slider/language-slider";
import { ActionType } from "../../../constants/enums/action-type-enum";
import { ModuleType } from "../../../constants/enums/module-type-enum";
import { isOperationPermittedRoleBase } from "../../../helpers/action-permission-helper";
import toast from "react-hot-toast";
import { formatMessage } from "../../../translations/format-message";

const AddEditAgreement = () => {
  const [editorValue, setEditorValue] = useState("");
  const { agreementManagementStore, masterManagementStore } = useStore();
  const { GetAllBusinessTypeListService, getAllBusinessTypes } =
    masterManagementStore;
  const history = useHistory();
  const {
    AddAgreementService,
    GetAgreementByIdService,
    getAgreementDetail,
    resetGetAgreementDetail,
    addUpdateAgreementState,
    UpdateAgreementService,
    deleteAgreementState,
  } = agreementManagementStore;

  const location = useLocation();
  const state = location.state as { AgreementId?: number };
  const AgreementId = state?.AgreementId || 0;
  useEffect(() => {
    if (AgreementId > 0) {
      GetAgreementByIdService(AgreementId);
    }
    return () => {
      resetGetAgreementDetail();
    };
    // use params to fetch edit values
  }, [AgreementId, GetAgreementByIdService]);

  const handleGoBack = () => {
    history.goBack();
  };

  useEffect(() => {
    if (addUpdateAgreementState.success) {
      if (AgreementId > 0) {
        toast.success(formatMessage("updated_success"));
      } else {
        toast.success(formatMessage("added_success"));
      }
      handleGoBack();
    }
  }, [addUpdateAgreementState.success, AgreementId]);


  

  const submitHandler = (values: any) => {
    if (AgreementId > 0) {
      UpdateAgreementService({
        Id: AgreementId,
        AgreementName: values.AgreementName,
        BusinessTypeId: Number(values.BusinessTypeId),
        Content: values.Content,
        IsValid: values.IsValid,
      });
    } else {
      AddAgreementService({
        AgreementName: values.AgreementName,
        BusinessTypeId: Number(values.BusinessTypeId),
        Content: values.Content,
        IsValid: values.IsValid,
      });
    }
  };

  useEffect(() => {
    GetAllBusinessTypeListService();
  }, [GetAllBusinessTypeListService]);

  return (
    <>
      <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav">
        <div className="row align-items-center">
          <div className="col-6">
            <div className="page_title_wrap">
              <h1 className="page_title">
                {AgreementId > 0 ? (
                  <FormattedMessage id="agreement_details" />
                ) : (
                  <FormattedMessage id="agreement_registration" />
                )}
              </h1>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <FormattedMessage id="various_settings" />
                </li>
                <li className="breadcrumb-item" aria-current="page">
                  <FormattedMessage id="agreement_list" />
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  {AgreementId > 0 ? (
                    <FormattedMessage id="agreement_details" />
                  ) : (
                    <FormattedMessage id="agreement_registration" />
                  )}
                </li>
              </ol>
            </div>
          </div>
          <div className="col-6">
            <ul className="add-list">
              <li>
                <LanguageSlider />
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="container-fluid mt-4 p-0">
        <AddEditAgreementForm
          id={AgreementId}
          initialValues={getAgreementDetail}
          isLoading={addUpdateAgreementState.inProgress}
          submitHandler={submitHandler}
          editorValue={editorValue}
          onCancel={handleGoBack}
          setEditorValue={setEditorValue}
          buisnessTypeOptions={getAllBusinessTypes}
          viewOnly={AgreementId > 0 ? !isOperationPermittedRoleBase(ModuleType.AgreementManegement, ActionType.Add) : false}
        />
      </div>
    </>
  );
};

export default observer(AddEditAgreement);
